import React, { Component } from 'react';


class IteamNumKeypadComponent extends Component {

    constructor(props) {
        super(props);
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.pointerDownHandlerForNumbers = this.pointerDownHandlerForNumbers.bind(this);
        this.pointerDownHandlerForBackspace = this.pointerDownHandlerForBackspace.bind(this);
        this.pointerDownHandlerForEnter = this.pointerDownHandlerForEnter.bind(this);
        
        this.numericKeyPad = React.createRef();
    }


    componentDidMount() {
        let componentWidth = this.numericKeyPad.current.offsetWidth;
        let numButtonLeft = this.props.numButtonLeft;
        let numButtonWidth = this.props.numButtonWidth;
        let componentLeft = Math.round(numButtonLeft - componentWidth / 2 + numButtonWidth / 2);
        this.numericKeyPad.current.style.left = `${componentLeft}px`;
        console.log('NUMPAD CALLING DISABLE GAME INPUTS');
        this.props.disableGameInputsCallback();
    }

    componentWillUnmount(){
        console.log('NUMPAD CALLING ENABLE GAME INPUTS');
        this.props.enableGameInputsCallback();
    }

    pointerDownHandlerForBackspace(event) {
        if (this.textField.value.length === 0) {
            return;
        }

        this.textField.value = this.textField.value.substr(0, this.textField.value.length - 1);
    }

    pointerDownHandlerForEnter(event) {
        this.props.showNumericKeyPad();
        if (this.textField.value === '') {
            return;
        }
        let pageNumber = +this.textField.value;
        this.props.gotoPageNumber(pageNumber);
    }

    pointerDownHandlerForNumbers(event) {
        if (event.target.innerText === '0' && this.textField.value.length === 0) {
            return;
        }

        if (this.textField.value.length >= 3) {
            return;
        }

        switch(event.target.innerText) {
            case '0':
            case '1':
            case '2':
            case '3':
            case '4':
            case '5':
            case '6':
            case '7':
            case '8':
            case '9':
                this.textField.value += event.target.innerText;
                break;
            default:
                break;
        }
    }

    keyDownHandler(event) {
        let target = event.target;


        switch (event.key) {
            case 'Backspace':
            case 'Delete':
            case 'ArrowLeft':
            case 'ArrowRight':
            case 'ArrowUp':
            case 'Enter':
                break;
            case '0':
            case '1':
            case '2':
            case '3':
            case '4':
            case '5':
            case '6':
            case '7':
            case '8':
            case '9':
                if (target.value.length >= 3) {
                    event.preventDefault();
                }
                break;
            default:
                event.preventDefault();
                break;
        }

        if (target.value.length === 0 && event.key === '0') {
            event.preventDefault();
            return;
        }

    }

    render() {
        return (<div className='numPad' ref={this.numericKeyPad}>
                <div className='numPadBlend'></div>
                <div className='numPadRow'>
                    <input type='text' ref={instance => this.textField = instance} 
                    onKeyDown={this.keyDownHandler} readOnly={true}/>
                </div>
                <div className='numPadRow'>
                    <div className='numPadCol numPadBottomBorder'>
                        <button onPointerDown={this.pointerDownHandlerForNumbers}>7</button>
                    </div>
                    <div className='numPadCol numPadLeftBorder numPadBottomBorder'>
                        <button onPointerDown={this.pointerDownHandlerForNumbers}>8</button>
                    </div>
                    <div className='numPadCol numPadLeftBorder numPadBottomBorder'>
                        <button onPointerDown={this.pointerDownHandlerForNumbers}>9</button>
                    </div>
                </div>
                <div className='numPadRow'>
                    <div className='numPadCol numPadBottomBorder'>
                        <button onPointerDown={this.pointerDownHandlerForNumbers}>4</button>
                    </div>
                    <div className='numPadCol numPadLeftBorder numPadBottomBorder'>
                        <button onPointerDown={this.pointerDownHandlerForNumbers}>5</button>
                    </div>
                    <div className='numPadCol numPadLeftBorder numPadBottomBorder'>
                        <button onPointerDown={this.pointerDownHandlerForNumbers}>6</button>
                    </div>
                </div>
                <div className='numPadRow'>
                    <div className='numPadCol numPadBottomBorder'>
                        <button onPointerDown={this.pointerDownHandlerForNumbers}>1</button>
                    </div>
                    <div className='numPadCol numPadLeftBorder numPadBottomBorder'>
                        <button onPointerDown={this.pointerDownHandlerForNumbers}>2</button>
                    </div>
                    <div className='numPadCol numPadLeftBorder numPadBottomBorder'>
                        <button onPointerDown={this.pointerDownHandlerForNumbers}>3</button>
                    </div>
                </div>
                <div className='numPadRow'>
                    <div className='numPadCol'>
                        <button onPointerDown={this.pointerDownHandlerForNumbers}>0</button>
                    </div>
                    <div className='numPadCol numPadLeftBorder'>
                        <button onPointerDown={this.pointerDownHandlerForBackspace}>
                            <svg viewBox="0 0 165.7 210.46"><polygon points="165.7 0 165.7 210.46 0 105.23 165.7 0"/></svg>
                        </button>
                    </div>
                    <div className='numPadCol numPadLeftBorder'>
                        <button onPointerDown={this.pointerDownHandlerForEnter}>
                            <svg viewBox="0 0 194.33 194.33"><path d="M182.57,5.76l-3.26-2a25,25,0,0,0-34.34,8L76.06,123.1,43.74,90.71a19.79,19.79,0,0,0-28,0l-10,10a19.9,19.9,0,0,0,0,28l52.31,52.44a24.76,24.76,0,0,0,5.88,5.9l1.45,1.45a19.78,19.78,0,0,0,19.79,4.9,24.89,24.89,0,0,0,17.63-11.52L190.6,40.18A25.11,25.11,0,0,0,182.57,5.76Z"/></svg>
                        </button>
                    </div>
                </div>
            </div>);
    }
}

export default IteamNumKeypadComponent;